export default __webpack_public_path__ + "static/media/AttestationPresence.76d0e0b3.jpg";